import React from "react";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";

const CommonModal = ({ show, onClose, title, children, size }) => (
  <Modal show={show} onHide={onClose} size={size} centered backdrop="static">
    {title && (
      <Modal.Header>
        <Modal.Title
          style={{
            fontSize: 24,
            fontWeight: "bold",
          }}
        >
          <p className="form-card-title">{title}</p>
        </Modal.Title>
        <CloseButton
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            outline: "none",
            fontSize: 35,
            color: "white",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        />
      </Modal.Header>
    )}
    <Modal.Body>{children}</Modal.Body>
  </Modal>
);

export default CommonModal;
